(function () {
  'use strict';

  var P = {
    cream: '#F3ECE4', creamDark: '#D9CBB8',
    mauve: '#EBD6DC', mauveDark: '#C98FA0',
    burgundy: '#5c1226', burgundyDark: '#3f0c19',
    ink: '#2b2b2b', inkDark: '#000000',
    gold: '#D8B877', goldDark: '#A9843F',
    blush: '#F6DCE2', blushDark: '#E3A9B8',
    silver: '#B7B2AC', silverDark: '#8C8680'
  };

  function tube(id, label, w, h, color, capColor) {
    var capH = Math.max(6, Math.round(h * 0.16));
    return { id: id, label: label, type: 'tube', w: w, h: h - capH, capW: Math.round(w * 0.55), capH: capH, color: color, capColor: capColor };
  }
  function round(id, label, d, color) { return { id: id, label: label, type: 'round', d: d, color: color }; }
  function brush(id, label, color) { return { id: id, label: label, type: 'brush', color: color }; }
  function palette(id, label, swatches) { return { id: id, label: label, type: 'palette', swatches: swatches }; }
  function photo(id, label, url) { return { id: id, label: label, type: 'photo', url: url }; }
  function flat(id, label, w, h, color) { return { id: id, label: label, type: 'flat', w: w, h: h, color: color }; }

  var mineeSmallItems = [
    tube('lip1', 'Lipstick', 14, 50, P.burgundy, P.burgundyDark),
    tube('lipliner', 'Lip Liner', 10, 42, P.burgundy, P.burgundyDark),
    round('compact1', 'Pressed Powder', 40, P.cream),
    tube('minibottle', 'Mini Perfume', 16, 34, P.gold, P.goldDark),
    tube('mascara1', 'Mascara', 13, 52, P.ink, P.inkDark),
    tube('concealer', 'Concealer', 14, 38, P.cream, P.creamDark),
    round('blush1', 'Blush Compact', 40, P.blush),
    tube('browpencil', 'Brow Pencil', 9, 42, P.ink, P.inkDark),
    brush('minibrush', 'Mini Brush', P.ink)
  ];
  var mineeSmallLight = ['lip1', 'lipliner', 'compact1', 'minibottle', 'mascara1'];

  var mineeMediumItems = [
    tube('foundation', 'Foundation', 30, 50, P.cream, P.creamDark),
    tube('lip2', 'Lipstick', 14, 50, P.burgundy, P.burgundyDark),
    tube('gloss', 'Lip Gloss', 13, 44, P.blush, P.blushDark),
    brush('brush2', 'Brush', P.ink),
    round('blush2', 'Blush Compact', 42, P.blush),
    tube('mascara2', 'Mascara', 14, 54, P.ink, P.inkDark),
    palette('palette1', 'Eyeshadow Palette', [P.mauve, P.mauveDark, P.cream, P.burgundy, P.blush, '#B9A88E']),
    tube('concealer2', 'Concealer', 15, 40, P.cream, P.creamDark),
    tube('lipliner2', 'Lip Liner', 10, 42, P.burgundy, P.burgundyDark),
    tube('perfume2', 'Mini Perfume', 18, 36, P.gold, P.goldDark),
    round('powder2', 'Setting Powder', 42, P.cream)
  ];
  var mineeMediumLight = ['foundation', 'lip2', 'gloss', 'brush2', 'blush2', 'mascara2'];

  var mineeLargeItems = [
    flat('l-straightener', 'Hair Straightener', 90, 20, P.ink),
    tube('l-hairspray', 'Hairspray', 24, 60, P.cream, P.creamDark),
    tube('l-foundation', 'Foundation', 32, 52, P.cream, P.creamDark),
    tube('l-concealer', 'Concealer', 16, 40, P.cream, P.creamDark),
    tube('l-lip1', 'Lipstick', 14, 50, P.burgundy, P.burgundyDark),
    round('l-blush', 'Blush Compact', 44, P.blush),
    brush('l-brush1', 'Brush', P.ink),
    palette('l-palette1', 'Eyeshadow Palette', [P.mauve, P.mauveDark, P.cream, P.burgundy, P.blush, '#B9A88E']),
    tube('l-mascara', 'Mascara', 14, 56, P.ink, P.inkDark),
    tube('l-perfume', 'Perfume', 28, 42, P.gold, P.goldDark),
    round('l-powder', 'Setting Powder', 42, P.cream),
    tube('l-serum', 'Serum', 22, 46, P.cream, P.creamDark),
    tube('l-dryshampoo', 'Dry Shampoo', 26, 56, P.silver, P.silverDark),
    tube('l-heatspray', 'Heat Protectant Spray', 24, 54, P.cream, P.creamDark),
    flat('l-comb', 'Hair Comb', 60, 14, P.ink),
    tube('l-handcream', 'Hand Cream', 20, 40, P.cream, P.creamDark)
  ];
  var mineeLargeLight = ['l-straightener', 'l-hairspray', 'l-foundation', 'l-lip1', 'l-blush', 'l-mascara'];

  var brushRollItems = [
    brush('br1', 'Foundation Brush', P.ink),
    brush('br2', 'Powder Brush', P.ink),
    brush('br3', 'Blush Brush', P.burgundy),
    brush('br4', 'Eyeshadow Brush', P.ink),
    brush('br5', 'Blending Brush', P.ink),
    brush('br6', 'Lip Brush', P.burgundy),
    brush('br7', 'Brow Brush', P.ink),
    brush('br8', 'Highlighter Brush', P.gold)
  ];
  var brushRollLight = ['br1', 'br2', 'br3', 'br4'];

  var homeeItems = [
    tube('foundation', 'Foundation', 32, 52, P.cream, P.creamDark),
    tube('concealer', 'Concealer', 16, 40, P.cream, P.creamDark),
    tube('lip1', 'Lipstick', 14, 50, P.burgundy, P.burgundyDark),
    tube('mascara', 'Mascara', 14, 56, P.ink, P.inkDark),
    round('blush1', 'Blush Compact', 44, P.blush),
    brush('brush1', 'Brush', P.ink),
    palette('palette1', 'Eyeshadow Palette', [P.mauve, P.mauveDark, P.cream, P.burgundy, P.blush, '#B9A88E']),
    tube('lipliner', 'Lip Liner', 10, 42, P.burgundy, P.burgundyDark),
    tube('eyeliner', 'Eyeliner', 12, 44, P.ink, P.inkDark),
    tube('jar1', 'Skincare', 40, 30, P.cream, P.creamDark),
    round('bronzer', 'Bronzer', 44, P.gold),
    tube('perfume', 'Perfume', 28, 42, P.gold, P.goldDark),
    tube('h-gloss2', 'Lip Gloss', 13, 44, P.blush, P.blushDark),
    tube('h-corrector', 'Colour Corrector', 14, 38, P.cream, P.creamDark),
    tube('h-serum', 'Serum', 22, 46, P.cream, P.creamDark),
    tube('h-tweezers', 'Tweezers', 7, 50, P.silver, P.silverDark),
    round('h-powder2', 'Setting Powder', 42, P.cream),
    tube('h-browpencil', 'Brow Pencil', 9, 42, P.ink, P.inkDark),
    round('h-highlighter', 'Highlighter', 40, P.gold),
    tube('h-lip3', 'Lipstick', 14, 48, P.blush, P.blushDark),
    round('h-mirror', 'Compact Mirror', 42, P.silver),
    round('h-cottonpads', 'Cotton Pads', 38, P.cream),
    tube('h-handcream', 'Hand Cream', 20, 40, P.cream, P.creamDark),
    flat('h-comb', 'Hair Comb', 60, 14, P.ink)
  ];
  var homeeLight = ['foundation', 'concealer', 'lip1', 'mascara', 'blush1', 'brush1', 'h-gloss2', 'h-browpencil', 'h-highlighter', 'h-mirror', 'h-handcream', 'h-powder2'];

  var bigeeItems = [
    tube('b-foundation', 'Foundation', 34, 54, P.cream, P.creamDark),
    tube('b-concealer', 'Concealer', 16, 42, P.cream, P.creamDark),
    tube('b-lip1', 'Lipstick', 14, 50, P.burgundy, P.burgundyDark),
    tube('b-lip2', 'Lipstick', 14, 50, P.blush, P.blushDark),
    round('b-blush', 'Blush Compact', 44, P.blush),
    tube('b-mascara', 'Mascara', 14, 58, P.ink, P.inkDark),
    brush('b-brush1', 'Brush Set', P.ink),
    tube('b-jar1', 'Skincare', 42, 32, P.cream, P.creamDark),
    palette('b-palette1', 'Eyeshadow Palette', [P.mauve, P.mauveDark, P.cream, P.burgundy, P.blush, '#B9A88E']),
    round('b-bronzer', 'Bronzer', 44, P.gold),
    tube('b-eyeliner', 'Eyeliner', 12, 44, P.ink, P.inkDark),
    brush('b-brush2', 'Brush', P.burgundy),
    tube('b-serum', 'Serum', 24, 46, P.cream, P.creamDark),
    tube('b-perfume', 'Perfume', 28, 42, P.gold, P.goldDark),
    tube('b-pencil1', 'Brow Pencil', 10, 46, P.ink, P.inkDark),
    tube('b-pencil2', 'Lip Liner', 10, 46, P.burgundy, P.burgundyDark),
    photo('b-brushroll', 'Brush Roll Holder', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/blush-pink-makeup-brush-holder-7265140.jpg?v=1775634083'),
    tube('b-tweezers', 'Tweezers', 7, 52, P.silver, P.silverDark),
    round('b-powder', 'Setting Powder', 44, P.cream),
    flat('b-hairiron', 'Hair Iron', 78, 20, P.ink),
    tube('b-gloss', 'Lip Gloss', 13, 44, P.blush, P.blushDark),
    tube('b-corrector', 'Colour Corrector', 14, 38, P.cream, P.creamDark),
    round('b-highlighter', 'Highlighter', 42, P.gold),
    round('b-mirror', 'Compact Mirror', 44, P.silver),
    tube('b-handcream', 'Hand Cream', 22, 42, P.cream, P.creamDark),
    round('b-cottonpads', 'Cotton Pads', 40, P.cream),
    flat('b-comb', 'Hair Comb', 70, 16, P.ink),
    tube('b-toner', 'Toner', 26, 50, P.cream, P.creamDark),
    tube('b-sunscreen', 'Sunscreen', 24, 48, P.cream, P.creamDark),
    round('b-nailpolish', 'Nail Polish', 30, P.burgundy)
  ];
  var bigeeLight = ['b-foundation', 'b-concealer', 'b-lip1', 'b-lip2', 'b-blush', 'b-mascara', 'b-brush1', 'b-jar1', 'b-gloss', 'b-highlighter', 'b-mirror', 'b-handcream', 'b-eyeliner', 'b-perfume', 'b-powder'];

  function bigeeEntry(title, image) {
    return {
      mode: 'single',
      title: title,
      image: image,
      dims: '27 × 18 × 13 cm',
      price: '$249.00',
      url: null,
      pieces: [{ title: null, cols: 5, items: bigeeItems, lightIds: bigeeLight }]
    };
  }

  function homeeEntry(title, image) {
    return {
      mode: 'single',
      title: title,
      image: image,
      dims: '27 × 13 × 13 cm',
      price: '$199.00',
      url: null,
      pieces: [{ title: null, cols: 5, items: homeeItems, lightIds: homeeLight }]
    };
  }

  function mineeMediumEntry(title, image) {
    return {
      mode: 'single',
      title: title,
      image: image,
      dims: '26 × 10 × 20 cm',
      price: '$99.00',
      url: null,
      pieces: [{ title: null, cols: 4, items: mineeMediumItems, lightIds: mineeMediumLight }]
    };
  }

  var DATA = {
    'minee-small-makeup-bag': {
      mode: 'single',
      title: 'Burgundy MINEE Small Makeup Bag',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/burgundy-minee-small-makeup-bag-w-dgold-chain-8921694.jpg?v=1777568287',
      dims: '23 × 8 × 15 cm',
      price: '$79.00',
      url: '/products/minee-small-makeup-bag',
      pieces: [{ title: null, cols: 5, items: mineeSmallItems, lightIds: mineeSmallLight }]
    },
    'minee-small-makeup-bag-pink': {
      mode: 'single',
      title: 'Pink MINEE Small Makeup Bag',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/minee-small-makeup-bag-pink-8156723.jpg?v=1786779426',
      dims: '23 × 8 × 15 cm',
      price: '$79.00',
      url: null,
      pieces: [{ title: null, cols: 5, items: mineeSmallItems, lightIds: mineeSmallLight }]
    },
    'minee-medium-makeup-bag-burgundy': mineeMediumEntry('Burgundy MINEE Medium Makeup Bag', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/minee-medium-makeup-bag-burgundy-4821132.jpg?v=1786779426'),
    'minee-medium-makeup-bag-pink': mineeMediumEntry('Pink MINEE Medium Makeup Bag', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/minee-medium-makeup-bag-pink-5781067.jpg?v=1786779426'),
    'minee-large-makeup-bag-burgundy': {
      mode: 'single',
      title: 'Burgundy MINEE Large Makeup Bag & Hair Tool Pouch',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/minee-large-makeup-bag-burgundy-pouch-9441081.jpg?v=1788105260',
      dims: '32 × 12 × 23 cm',
      price: '$129.00',
      url: null,
      pieces: [{ title: null, cols: 5, items: mineeLargeItems, lightIds: mineeLargeLight }]
    },
    'new-minee-trio-burgundy-makeup-bag-set-bonus-brush-roll-holder': {
      mode: 'bundle',
      title: 'MINEE Trio Burgundy Makeup Bag Set + Brush Roll Holder',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/new-minee-trio-burgundy-makeup-bag-set-bonus-brush-roll-holder-4064017.jpg?v=1789596666',
      dims: 'Four pieces · 23×8×15 + 26×10×20 + 32×12×23 cm + Brush Roll',
      price: '$289.00',
      url: null,
      pieces: [
        { title: 'MINEE Small', cols: 3, items: mineeSmallItems, lightIds: mineeSmallLight },
        { title: 'MINEE Medium', cols: 3, items: mineeMediumItems, lightIds: mineeMediumLight },
        { title: 'MINEE Large', cols: 3, items: mineeLargeItems, lightIds: mineeLargeLight },
        { title: 'Brush Roll Holder', cols: 4, items: brushRollItems, lightIds: brushRollLight }
      ]
    },
    'minee-bundle-pink': {
      mode: 'bundle',
      title: 'Pink MINEE Small + Medium Makeup Bag Bundle',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/pink-minee-pouch-bundle-small-medium-8698674.jpg?v=1774912871',
      dims: 'Two pieces · 23×8×15 cm + 26×10×20 cm',
      price: '$178.00',
      url: '/products/minee-bundle?variant=52406395994424',
      pieces: [
        { title: 'MINEE Small', cols: 3, items: mineeSmallItems, lightIds: mineeSmallLight },
        { title: 'MINEE Medium', cols: 3, items: mineeMediumItems, lightIds: mineeMediumLight }
      ]
    },
    'pink-homee-medium-makeup-bag-designer-cosmetic-case': homeeEntry('HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/pink-homee-medium-beauty-case-8085427.png?v=1786447987'),
    'pink-homee-medium-makeup-bag-designer-cosmetic-case-1': homeeEntry('Pink HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/pink-homee-medium-beauty-case-8233717.png?v=1786530846'),
    'blush-pink-homee-medium-makeup-bag-designer-beauty-case': homeeEntry('Blush Pink HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/homee-medium-makeup-bag-designer-cosmetic-case-3286638.jpg?v=1777568295'),
    'white-homee-medium-makeup-bag-designer-cosmetic-case': homeeEntry('White HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/homee-medium-makeup-bag-designer-cosmetic-case-6590069.jpg?v=1777568296'),
    'black-homee-medium-makeup-bag-designer-cosmetic-case': homeeEntry('Black HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/black-homee-medium-makeup-bag-designer-cosmetic-case-1140868.jpg?v=1777568294'),
    'silver-homee-medium-makeup-bag-designer-cosmetic-case': homeeEntry('Silver HOMEE Medium Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/homee-medium-makeup-bag-designer-cosmetic-case-7695538.jpg?v=1777568367'),
    'pink-bigee-large-beauty-travel-case': bigeeEntry('Pink BIGEE Large Beauty Travel Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/bigee-large-makeup-bag-designer-cosmetic-case-6287012.png?v=1777568414'),
    'white-bigee-large-beauty-travel-case': bigeeEntry('White BIGEE Large Travel Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/white-bigee-large-makeup-bag-designer-cosmetic-case-3141290_7e379389-5960-4e68-98d5-9350122a5bdb.jpg?v=1775684278'),
    'silver-bigee-large-beauty-travel-case': bigeeEntry('Silver BIGEE Large Beauty Travel Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/bigee-large-makeup-bag-designer-cosmetic-case-9888425.jpg?v=1777568414'),
    'blush-pink-bigee-large-beauty-travel-case': bigeeEntry('Blush Pink BIGEE Large Beauty Travel Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/Estetika_0007_187e84a9-db80-4963-8612-b91e97186b5c.jpg?v=1775684278'),
    'black-bigee-large-beauty-travel-case': bigeeEntry('Black BIGEE Large Beauty Travel Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/bigee-large-makeup-bag-designer-cosmetic-case-4904405.jpg?v=1777568415'),
    'pink-large-quilted-makeup-bag-luxury-vegan-beauty-case-bigee': bigeeEntry('BIGEE Large Travel Beauty Case', 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/custom-bundle-mix-and-match-upto-25-2218368.jpg?v=1777568289'),
    'minee-bundle': {
      mode: 'bundle',
      title: 'Burgundy MINEE Small + Medium Makeup Bag Bundle',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/burgundy-minee-bundle-small-medium-1368701.jpg?v=1774912871',
      dims: 'Two pieces · 23×8×15 cm + 26×10×20 cm',
      price: '$178.00',
      url: '/products/minee-bundle',
      pieces: [
        { title: 'MINEE Small', cols: 3, items: mineeSmallItems, lightIds: mineeSmallLight },
        { title: 'MINEE Medium', cols: 3, items: mineeMediumItems, lightIds: mineeMediumLight }
      ]
    },
    'bestseller-bundle': {
      mode: 'bundle',
      title: 'Pink HOMEE + BIGEE Travel Beauty Case Bundle',
      image: 'https://cdn.shopify.com/s/files/1/0673/0675/0264/files/bestseller-pink-makeup-bag-bundle-the-homee-bigee-2381239.jpg?v=1777568292',
      dims: 'Two pieces · 27×13×13 cm + 27×18×13 cm',
      price: '$448.00',
      url: '/products/bestseller-bundle',
      pieces: [
        { title: 'HOMEE Medium', cols: 3, items: homeeItems, lightIds: homeeLight },
        { title: 'BIGEE Large', cols: 4, items: bigeeItems, lightIds: bigeeLight }
      ]
    }
  };

  // Maps dedicated ad-landing-page handles (/pages/<handle>) to the DATA key
  // for the matching product, so the same trigger/modal works there too.
  var PAGE_MAP = {
    'homee-black': 'black-homee-medium-makeup-bag-designer-cosmetic-case',
    'homee-pink': 'pink-homee-medium-makeup-bag-designer-cosmetic-case-1',
    'homee-blush': 'blush-pink-homee-medium-makeup-bag-designer-beauty-case',
    'homee-silver': 'silver-homee-medium-makeup-bag-designer-cosmetic-case',
    'homee-white': 'white-homee-medium-makeup-bag-designer-cosmetic-case',
    'bigee-black': 'black-bigee-large-beauty-travel-case',
    'bigee-pink': 'pink-bigee-large-beauty-travel-case',
    'bigee-blush': 'blush-pink-bigee-large-beauty-travel-case',
    'bigee-silver': 'silver-bigee-large-beauty-travel-case',
    'bigee-white': 'white-bigee-large-beauty-travel-case',
    'minee-small-burgundy': 'minee-small-makeup-bag',
    'minee-small-pink': 'minee-small-makeup-bag-pink',
    'minee-medium-burgundy': 'minee-medium-makeup-bag-burgundy',
    'minee-medium-pink': 'minee-medium-makeup-bag-pink',
    'minee-large-burgundy': 'minee-large-makeup-bag-burgundy',
    'minee-trio-burgundy': 'new-minee-trio-burgundy-makeup-bag-set-bonus-brush-roll-holder',
    'minee-bundle-burgundy': 'minee-bundle',
    'minee-bundle-pink': 'minee-bundle-pink'
  };

  // HOMEE and BIGEE landing pages have an in-page colour swatch selector
  // (.es-swatches, buttons with data-c="black|pink|blush|silver|white")
  // that swaps the hero photo and variant client-side without navigating.
  // Maps that swatch colour to the matching DATA key per product size, so
  // the "See What Fits" trigger can be kept in sync with whichever colour
  // is currently selected, not just the page's default colour.
  var SWATCH_COLOR_MAP = {
    homee: {
      black: 'black-homee-medium-makeup-bag-designer-cosmetic-case',
      pink: 'pink-homee-medium-makeup-bag-designer-cosmetic-case-1',
      blush: 'blush-pink-homee-medium-makeup-bag-designer-beauty-case',
      silver: 'silver-homee-medium-makeup-bag-designer-cosmetic-case',
      white: 'white-homee-medium-makeup-bag-designer-cosmetic-case'
    },
    bigee: {
      black: 'black-bigee-large-beauty-travel-case',
      pink: 'pink-bigee-large-beauty-travel-case',
      blush: 'blush-pink-bigee-large-beauty-travel-case',
      silver: 'silver-bigee-large-beauty-travel-case',
      white: 'white-bigee-large-beauty-travel-case'
    }
  };

  // Some landing-page hero photos have a badge/seal baked into the image
  // near the top (e.g. an award seal). The hero box is wider than the
  // source photo, so object-fit:cover crops top/bottom to fill it — on
  // narrow screens that crop can slice through a badge sitting at the top
  // edge. Anchoring the crop to the top keeps those badges fully visible;
  // only pages whose hero photo actually has a top badge are listed here.
  var HERO_TOP_ANCHOR_PAGES = ['bigee-black'];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function renderShape(item) {
    switch (item.type) {
      case 'tube':
        return '<div class="wi-shape"><div class="wi-tube-cap" style="width:' + item.capW + 'px;height:' + item.capH + 'px;background:' + item.capColor + ';"></div><div class="wi-tube-body" style="width:' + item.w + 'px;height:' + item.h + 'px;background:' + item.color + ';"></div></div>';
      case 'round':
        return '<div class="wi-shape"><div class="wi-round" style="width:' + item.d + 'px;height:' + item.d + 'px;background:' + item.color + ';"></div></div>';
      case 'brush':
        return '<div class="wi-shape"><div class="wi-bristle" style="background:' + item.color + ';"></div><div class="wi-handle"></div></div>';
      case 'palette':
        return '<div class="wi-shape"><div class="wi-palette">' + item.swatches.map(function (c) { return '<div style="background:' + c + ';"></div>'; }).join('') + '</div></div>';
      case 'photo':
        return '<div class="wi-shape"><img src="' + item.url + '" alt="' + esc(item.label) + '" class="wi-photo-item"></div>';
      case 'flat':
        return '<div class="wi-shape"><div class="wi-flat" style="width:' + item.w + 'px;height:' + item.h + 'px;background:' + item.color + ';border-radius:' + (item.h / 2) + 'px;"></div></div>';
    }
    return '';
  }

  function itemCell(item) {
    return '<div class="wi-item">' + renderShape(item) + '<div class="wi-item-label">' + esc(item.label) + '</div></div>';
  }

  function piecesHTML(data, level) {
    var isBundle = data.pieces.length > 1;
    var total = 0;
    var html = data.pieces.map(function (piece) {
      var filtered = level === 'light' ? piece.items.filter(function (i) { return piece.lightIds.indexOf(i.id) !== -1; }) : piece.items;
      total += filtered.length;
      var header = piece.title ? '<div class="wi-piece-title">' + esc(piece.title) + ' &middot; ' + filtered.length + ' items</div><div class="wi-piece-divider"></div>' : '';
      var grid = '<div class="wi-grid" style="grid-template-columns:repeat(' + piece.cols + ',1fr);">' + filtered.map(itemCell).join('') + '</div>';
      return '<div class="' + (isBundle ? 'wi-piece-card' : 'wi-piece-full') + '">' + header + grid + '</div>';
    }).join('');
    return { html: html, total: total };
  }

  function buildModal(data) {
    var isBundle = data.pieces.length > 1;
    var head = '<div class="wi-header"><div class="wi-brand">ESTETIKA &mdash; What’s Inside</div><button class="wi-close" aria-label="Close">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#232323" stroke-width="2" stroke-linecap="round"><line x1="4" y1="4" x2="20" y2="20"></line><line x1="20" y1="4" x2="4" y2="20"></line></svg></button></div>';

    var top;
    if (isBundle) {
      top = '<div class="wi-bundle-hero">' +
        '<img src="' + data.image + '" alt="' + esc(data.title) + '">' +
        '<div class="wi-bundle-info"><div class="wi-single-title">' + esc(data.title) + '</div><div class="wi-single-dims">' + esc(data.dims) + '</div><div class="wi-price">' + esc(data.price) + '</div></div>' +
        '<a class="wi-shop-btn" href="' + data.url + '">Shop The Bundle</a>' +
        '</div>';
    } else {
      top = '';
    }

    var toolbar = '<div class="wi-toolbar"><div class="wi-count"><strong id="wi-count-num">0</strong> real products that fit' + (isBundle ? ', across both pieces' : ' inside') + '</div>' +
      '<div class="wi-toggle"><button class="wi-toggle-btn" data-wi-level="light">Everyday Essentials</button><button class="wi-toggle-btn" data-wi-level="full">Full Travel Routine</button></div></div>';

    var body;
    if (isBundle) {
      body = '<div class="wi-body">' + top + toolbar + '<div class="wi-pieces wi-pieces--bundle" id="wi-pieces"></div></div>';
    } else {
      body = '<div class="wi-body wi-body--single">' +
        '<div class="wi-single-photo"><img src="' + data.image + '" alt="' + esc(data.title) + '"><div class="wi-single-title">' + esc(data.title) + '</div><div class="wi-single-dims">' + esc(data.dims) + '</div></div>' +
        '<div class="wi-single-main">' + toolbar + '<div class="wi-pieces" id="wi-pieces"></div>' +
        '<div class="wi-footer"><div><div class="wi-footer-title">' + esc(data.title) + '</div><div class="wi-price">' + esc(data.price) + '</div></div><a class="wi-shop-btn" href="' + (data.url || '#') + '">Shop Now</a></div>' +
        '</div></div>';
    }

    return '<div class="wi-modal">' + head + body + '</div>';
  }

  var currentData = null;
  var currentLevel = 'full';

  function update() {
    if (!currentData) return;
    var r = piecesHTML(currentData, currentLevel);
    var piecesEl = document.getElementById('wi-pieces');
    if (piecesEl) piecesEl.innerHTML = r.html;
    var countEl = document.getElementById('wi-count-num');
    if (countEl) countEl.textContent = r.total;
    var btns = document.querySelectorAll('[data-wi-level]');
    for (var i = 0; i < btns.length; i++) {
      var isActive = btns[i].getAttribute('data-wi-level') === currentLevel;
      btns[i].classList.toggle('is-active', isActive);
    }
  }

  function openModal(handle) {
    var data = DATA[handle];
    if (!data) return;
    if (!data.url) data.url = '/products/' + handle;
    currentData = data;
    currentLevel = 'full';
    var overlay = document.getElementById('wi-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'wi-overlay';
      overlay.className = 'wi-overlay';
      document.body.appendChild(overlay);
    }
    overlay.innerHTML = buildModal(data);
    overlay.classList.add('wi-overlay--open');
    document.documentElement.style.overflow = 'hidden';

    overlay.querySelector('.wi-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    var toggleBtns = overlay.querySelectorAll('[data-wi-level]');
    for (var i = 0; i < toggleBtns.length; i++) {
      toggleBtns[i].addEventListener('click', function (e) {
        currentLevel = e.currentTarget.getAttribute('data-wi-level');
        update();
      });
    }
    update();
  }

  function closeModal() {
    var overlay = document.getElementById('wi-overlay');
    if (overlay) overlay.classList.remove('wi-overlay--open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-whats-inside-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-whats-inside-trigger'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  var TRIGGER_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 8V6.5A2.5 2.5 0 0 1 11.5 4h1A2.5 2.5 0 0 1 15 6.5V8"></path><rect x="4" y="8" width="16" height="11.5" rx="2"></rect><path d="M4 13.2h16"></path></svg> See What Fits';

  function injectTrigger() {
    var pv = document.querySelector('.productView[data-product-handle]');
    if (!pv) return;
    var handle = pv.getAttribute('data-product-handle');
    if (!DATA[handle]) return;
    var gallery = pv.querySelector('.halo-productView-left');
    if (!gallery || gallery.querySelector('[data-whats-inside-trigger]')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wi-trigger';
    btn.setAttribute('data-whats-inside-trigger', handle);
    btn.innerHTML = TRIGGER_SVG;
    gallery.appendChild(btn);
  }

  // The dedicated ad landing pages (/pages/<handle>) are plain Shopify Page
  // templates, not product pages, so they have no .productView wrapper.
  // Each one centers on a single bleed hero image (.es-heroimg.es-bleed) —
  // anchor the same trigger/modal there instead, keyed off the page handle.
  function injectTriggerOnLandingPage() {
    var m = window.location.pathname.match(/^\/pages\/([^\/]+)/);
    if (!m) return;
    var handle = PAGE_MAP[m[1]];
    if (!handle || !DATA[handle]) return;
    var heroImgWrap = document.querySelector('.es-heroimg.es-bleed');
    if (!heroImgWrap || heroImgWrap.querySelector('[data-whats-inside-trigger]')) return;
    heroImgWrap.style.position = 'relative';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wi-trigger';
    btn.setAttribute('data-whats-inside-trigger', handle);
    btn.innerHTML = TRIGGER_SVG;
    heroImgWrap.appendChild(btn);
  }

  // Keeps the "See What Fits" trigger pointed at whichever colour is
  // currently selected on the swatch selector, instead of staying locked
  // to the page's default colour after a customer switches swatches.
  function syncTriggerToSwatches() {
    var m = window.location.pathname.match(/^\/pages\/([^\/]+)/);
    if (!m) return;
    var category = null;
    if (m[1].indexOf('homee-') === 0) category = 'homee';
    else if (m[1].indexOf('bigee-') === 0) category = 'bigee';
    if (!category) return;

    var swatchWrap = document.querySelector('.es-swatches');
    if (!swatchWrap || swatchWrap.getAttribute('data-wi-synced')) return;
    swatchWrap.setAttribute('data-wi-synced', 'true');

    swatchWrap.addEventListener('click', function (e) {
      var swBtn = e.target.closest('.es-sw[data-c]');
      if (!swBtn) return;
      var color = swBtn.getAttribute('data-c');
      var key = SWATCH_COLOR_MAP[category] && SWATCH_COLOR_MAP[category][color];
      if (!key || !DATA[key]) return;
      var triggerBtn = document.querySelector('[data-whats-inside-trigger]');
      if (triggerBtn) triggerBtn.setAttribute('data-whats-inside-trigger', key);
    });
  }

  function fixHeroImagePosition() {
    var m = window.location.pathname.match(/^\/pages\/([^\/]+)/);
    if (!m || HERO_TOP_ANCHOR_PAGES.indexOf(m[1]) === -1) return;
    var heroImg = document.querySelector('.es-heroimg.es-bleed img');
    if (!heroImg) return;
    heroImg.style.objectPosition = '50% 0%';
  }

  function injectTriggers() {
    injectTrigger();
    injectTriggerOnLandingPage();
    syncTriggerToSwatches();
    fixHeroImagePosition();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTriggers);
  } else {
    injectTriggers();
  }

  // Shopify's theme editor (Customize) re-renders sections via AJAX after
  // initial load, which wipes out DOM nodes injected on first load. Re-run
  // on every section load/select so the button survives editor re-renders.
  document.addEventListener('shopify:section:load', injectTriggers);
  document.addEventListener('shopify:section:select', injectTriggers);
  if (window.Shopify && Shopify.designMode) {
    setInterval(injectTriggers, 1500);
  }

  // Exposed so other scripts (the quiz page) can reuse the same product
  // data and "what's inside" rendering without duplicating it.
  window.EstetikaWI = {
    DATA: DATA,
    esc: esc,
    renderShape: renderShape,
    itemCell: itemCell,
    piecesHTML: piecesHTML
  };
})();
